module.exports = __webpack_public_path__ + "img/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.7aecbbb0.webp";